import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "c-magic-line c-magic-line--underline inline" }

import useFreightInformation from '@/shared/product/freight-information/useFreightInformation';
import { computed } from 'vue';
import useGlobalLabels from '@/shared/content/useGlobalLabels';
import { GlobalLabels } from '@/shared/content/site-context.store';


export default /*#__PURE__*/_defineComponent({
  __name: 'FreightInfoButton',
  props: {
    hasFreightInformation: { type: Boolean },
    buttonCss: null
  },
  setup(__props: any) {

const props = __props as {
    hasFreightInformation?: boolean;
    buttonCss: string;
}



const { freightInfo, setProductFreightInfo, toggleFreightInfo } = useFreightInformation();
const freightInformationEnabled = computed(() => props.hasFreightInformation);

const globalLabels = useGlobalLabels(GlobalLabels.product);

const clickedFreightInfoButton = () => {
    setFreightInfo();
    toggleFreightInfo();
};

const setFreightInfo = () => {
    if (freightInfo.value) { return; }
    setProductFreightInfo();
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    name: "o-anim-fade-300",
    appear: ""
  }, {
    default: _withCtx(() => [
      (_unref(freightInformationEnabled))
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: _normalizeClass(__props.buttonCss),
            tabindex: "-1",
            onClick: clickedFreightInfoButton
          }, [
            _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(globalLabels).freightInfoButton), 1)
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})